<template>
  <BContainer
    class="vh-100 d-flex justify-content-center align-items-center flex-column"
  >
    <BImg
      :src="require('@/assets/images/error/error-01.png')"
      class="mb-5"
      style="width: 50vw;"
    />
    <p class="text-center h3">
      Oops! Page not Found.
    </p>
    <p class="text-center">
      The requested page does not exist.
    </p>
    <router-link
      class="btn btn-success mt-3"
      :to="{ name: user ? `${user?.role}.dashboard` : 'shared.login' }"
    >
      <i class="ri-home-4-line" />Back to Home
    </router-link>
  </BContainer>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SharedPageNotFound',
  computed: mapGetters({
    user: 'auth/user'
  })
}
</script>
